<template>
  <div class="fullHeight">
    <MypageSideMenu :memberDropClose="true"/>
    <Card
        :page_title="page_title"
        iconclass="icon-icon-info mypage-title-icon"
    >
      <!-- 以下内容 -->
      <!-- <div class="reseveTabletitle mb-3 font-weight-bold">{{ page_title }}</div> -->
        <table class="table table-striped listTable">
            <thead class="sp_not">
                <tr>
                    <th class="text-left width-210" scope="col">投稿日時</th>
                    <th class="text-left min-width-35" scope="col">件名</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="actualsList.length === 0">
                    <tr>
                        <td colspan="2" class="text-center">お知らせはございません。</td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-for="data in actualsList" :key="data.id">
                        <td class="max-width-35 d-flex justify-content-between d-sm-table-cell">
                            <span class="sp_label">投稿日時</span>
                            <a @click="gotoDeliveryActualsReference(data)" href="#">{{ data.delivery_date | replace('-','/') }}</a>
                        </td>
                        <td class="max-width-50 d-flex justify-content-between d-sm-table-cell text-break flex-column flex-sm-row">
                            <span class="sp_label">件名</span>
                            <span>{{ title(data.delivery_contents) | truncate(20) }}</span>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <nav aria-label="Page navigation" class="w-100">
            <ul class="pagination pagination-sm">
                <li class="page-item" @click="ClickPagination('Previous')">
                    <span class="framebutton Mypagepoint_pagelinkwidth">前へ</span>
                </li>
                <li class="pagination-center">
                    <span>{{ pagination }} / {{ maxPaginationNotReturnZero }}</span>
                </li>
                <li class="page-item" @click="ClickPagination('Next')">
                    <span class="framebutton Mypagepoint_pagelinkwidth">次へ</span>
                </li>
            </ul>
        </nav>
    </Card>
    <MypageMenuFooter/>
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import { GET_DELIVERY_ACTUALS_LIST } from '../../constants/delivery_actuals';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        Card
    },
    data () {
        return {
            memberNo: '',
            page_title: 'お知らせ一覧',
            // 詳細画面に渡す値
            reference: {
                delivery_id: '',
                delivery_date: '',
                member_no: '',
                reserve_no: ''
            },
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            // お知らせ一覧
            actualsList: [],
            // 表示中のページネーション番号
            pagination: 1,
            // 最大ページネーション数(初期表示)
            maxPagination: 1,
            // 一覧取得の開始値
            begin_row: 0,
            // 一覧の最大表示値
            limit_rows: 10
        };
    },
    created () {
        this.memberNo = this.$store.state.auth.loginMember.member_no;
        this.getActualsList();
    },
    computed: {
        maxPaginationNotReturnZero () {
            return this.maxPagination === 0 ? 1 : this.maxPagination;
        }
    },
    methods: {
          /** ----------------------------------------------
         * ページネーション処理
         * ---------------------------------------------- */
        ClickPagination: function (mode) {
            // 前へボタン押下時処理
            if (mode === 'Previous') {
                if (this.pagination > 1) {
                    this.pagination--;
                    if (this.display_pagination === 1) {
                        this.begin_row = 0;
                    } else {
                        this.begin_row = this.begin_row - this.limit_rows;
                    }
                    this.getActualsList();
                } else {
                    return;
                }
            } else {
                // 次へボタン押下時処理
                if (this.pagination < this.maxPagination) {
                    this.begin_row = this.begin_row + this.limit_rows;
                    this.pagination++;
                    this.getActualsList();
                } else {
                    return;
                }
            }
        },
        /** ----------------------------------------------
         * お知らせ一覧を取得
         * ---------------------------------------------- */
        getActualsList () {
            this.$apollo.mutate({
                fetchPolicy: 'no-cache',
                mutation: GET_DELIVERY_ACTUALS_LIST,
                variables: {
                    member_no: this.memberNo,
                    limit: this.limit_rows,
                    offset: this.begin_row
                }
            }).then(res => {
                const data = res.data.getDeliveryActualsList.DeliveryActualsList;
                const totalCount = res.data.getDeliveryActualsList.totalCount;
                this.maxPagination = Math.ceil(totalCount / this.limit_rows);
                this.actualsList.splice(0, this.actualsList.length);
                data.forEach(el => {
                    this.actualsList.push(el);
                });
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
            })
        },
        gotoDeliveryActualsReference (data) {
            this.$store.commit("delivery/setDelivery_date", data.delivery_date);
            this.$store.commit("delivery/setDelivery_contents", data.delivery_contents);
            this.$router.push({ path: '/mypage-delivery-actuals-reference' });
        },
        title(contents){
            const arrTitle = contents.split(/\\n/g);
            return arrTitle[0];
        }
    },
    filters: {
        truncate(value, n, o) {
            let len = +n
            let suffix = o ? o.toString() : '...'
            if (value.length <= len) return value
            return value.substring(0, len) + suffix
        }
    }
}

</script>

<style scoped>
a{
    text-decoration: underline;
}
.table td{
    vertical-align: inherit;
    padding: 7px;
}
.anchorDisabled{
    background-color: #6c757d;
    opacity: 0.65;
    border: none;
}
@media screen and (max-width: 896px) {
  .sp_label{
      min-width: 10rem;
  }
}
</style>
